import type { SuggestionKeyDownProps, SuggestionProps } from '@tiptap/suggestion';

import type { EditorPluginConfig, QuickAction } from './../../ricos-types';

export interface QuickActionsEditorConfig extends EditorPluginConfig {
  shouldCreate?: () => {
    desktop?: boolean;
    mobile?: {
      ios?: boolean;
      android?: boolean;
    };
  };
  activateOnFloatingPlusButton?: boolean;
  customPlaceholder?: string;
}

export const QUICK_ACTIONS = 'quickActions';
export const QUICK_ACTIONS_MODAL_ID = `${QUICK_ACTIONS}.modal`;

export type QuickActionsModalRef = {
  onKeyDown?: (props: SuggestionKeyDownProps) => boolean;
};

export interface QuickActionsModalProps
  extends Partial<Omit<SuggestionProps<QuickAction>, 'items'>> {
  openedThroughModalService?: boolean;
}
